module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDATOR AND")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REY")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "chquote"
  }, [_vm._v("At 7:47 P.M. on August 4 we received the message, “Prepare for war with England.”")])]), _c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("—Admiral Reinhard Scheer, "), _c('i', [_vm._v("Germany’s High Sea Fleet")]), _vm._v(", 1920"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_1",
      "id": "fn1_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _vm._v("fter massing her troops along the Belgian border on the 3rd of August, 1914, Germany declared war on France. An ultimatum that Germany respect Belgian neutrality and withdraw was immediately sent by Britain, and summarily rejected. The British ambassador to Berlin, Sir Edward Goschen, was recalled and at 11:00 p.m. on the 4th, Britain declared war. With an efficiency brought by a newly-mechanized twentieth century, German invasion forces rapidly crossed into Belgium and soon established a front along the northern border of France. When Admiral Reinhard Scheer received the message to prepare for war with England, the Imperial German Navy, the "), _c('i', [_vm._v("Kaiserliche Marine")]), _vm._v(", was ready.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Earlier that day on the 4th, the auxiliary minelayer "), _c('i', [_vm._v("Königin Luise")]), _vm._v(", already at sea, received the wireless message: “Make for sea in Thames direction at top speed. Lay mines near as possible the English coasts …”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_2",
      "id": "fn1_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" It was on August 5, the day after Britain declared war, that the minelayer completed her mission, but had been discovered by British destroyers; after a brief chase "), _c('i', [_vm._v("Königin Luise")]), _vm._v(" was sent to the bottom. In less than twenty-four hours, however, the mines had done their work when one of them was struck by HMS "), _c('i', [_vm._v("Amphion")]), _vm._v(", which soon shared the minelayer’s fate. War had arrived off the British Isles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout Europe, Germany had been perceived as a military powerhouse after her swift victory during the Franco-Prussian War in 1871. For three decades, Germany’s High Seas Fleet had been gathering strength and was anxious to prove itself against what the British unabashedly referred to as The Grand Fleet. Unprepared for the scale of aggression brought by their belligerent neighbor on the continent, the British Admiralty scrambled to meet what was obvious to everyone—that this war would quickly expand beyond the battlefields of Europe and onto the surrounding seas. "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("What was less obvious was that the war would also slip beneath the surface of the ocean.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Admiral Reinhard Scheer, who became Commander in Chief of the High Seas Fleet in January, 1916, and later Chief of the Admiralty Staff, noted in his memoir: “[A] decision was taken which was extremely important for the further course of the war … for the U-boats received orders to proceed on August 6 [1914] against English battleships, the presence of which was suspected in the North Sea.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_3",
      "id": "fn1_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" These orders would set the stage for additional forays into the waters between Britain and Germany. On the morning of September 22, Otto Weddigen, in command of "), _c('i', [_vm._v("U-9")]), _vm._v(" with a crew of four officers and twenty-five enlisted, sent torpedoes into the sides of three British armored cruisers, "), _c('i', [_vm._v("Aboukir, Cressy")]), _vm._v(", and "), _c('i', [_vm._v("Hogue")]), _vm._v(", all three sinking within an hour with a loss of over 1400 officers and crew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The success of a single submarine, and a nearly obsolete one at that, had surprised not only the British, but Germany as well. Maybe the Grand Fleet was not so grand after all. Construction of bigger, faster, better armed submarines would become a priority at Krupp-Germania and other German shipyards. No longer just a vessel designed for coastal defense, the U-boat fleet soon had the capability to spend weeks—even months—at sea, covering thousands of miles. They could now lay mine fields across harbors, undetected. They carried large caliber guns mounted on deck which could engage Allied shipping on the surface, saving their torpedoes for higher value, higher tonnage targets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A massive engagement between the Grand Fleet and the High Seas Fleet was inevitable, where dreadnaughts, battleships, cruisers, and destroyers on both sides pummeled each other with their massive firepower. This confrontation occurred over two days, May 31 to June 1, 1916, at the Battle of Jutland—known in Germany as the Battle of the Skagerrak. Both sides claimed victory, but ended any further major engagements between the surface fleets of Britain and Germany; future naval operations during the Great War would be defined beneath the sea."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_4",
      "id": "fn1_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Britain had depended on the Grand Fleet to deal with warfare on the open ocean, and the Admiralty’s first priority was to mobilize all of its resources—old ships reconditioned; new ships designed and built; manpower recruited. Submarines and the deadly torpedoes they carried, however, soon defined the realities of the twentieth-century, and antisubmarine warfare would also have to become a priority. Yet in 1914, no one really understood the complexity of the submarine problem nor the technology that would be needed to counter the threat.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORPEDO")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBMARINE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPLOSIONS")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("I endeavoured for many years to get torpedoes introduced into practice in France, and in England; which, though unsuccessful, gave me the opportunity of making numerous very interesting experiments on a large scale …”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_5",
      "id": "fn1_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Robert Fulton published his pamphlet “Torpedo War and Submarine Explosions” in 1810 as another war with England seemed inevitable. Fulton was attempting to convince Congress that his device could be “so arranged as to blow up a vessel which should run against it …”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_6",
      "id": "fn1_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" He had already been unsuccessful in selling his concept of a submarine, his "), _c('i', [_vm._v("Nautilus")]), _vm._v(", to the French and English, and had turned to other methods of using underwater explosives. The word “torpedo” was apparently coined by Fulton during the first decade of the nineteenth century. In a September 6, 1807 letter from British Commodore E. W. C. R. Owen, distributed among the Admiralty, Owen included a “Description of the Machine invented by Mr. Robert Fulton for exploding under Ship’s Bottoms and by him called the Torpedo.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_7",
      "id": "fn1_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" The term, however, was in reference to what is now referred to as a tethered subsurface mine. The following extracts are from the September 9, 1807 edition of the "), _c('i', [_vm._v("Connecticut Current")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("[T]hese aquatic incendiaries have come forward at the present alarming juncture, and announced a most potent discovery, which is to guarantee our port from the visit of any foreign marauders … a cunning machine shrewdly y’clep’d a "), _c('i', [_vm._v("Torpedo")]), _vm._v(", by which the stoutest line of battle ship … may be caught napping, and "), _c('i', [_vm._v("decomposed")]), _vm._v(" in a twinkling."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_8",
      "id": "fn1_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The War of 1812 was primarily a naval war. There were stories of a submarine built by Silas Clowden Halsey, reportedly used in 1814 against a British warship anchored at the harbor of New London, Connecticut. Hartford’s Samuel Colt, who had proposed the use of electrically triggered underwater mines in the 1840s, drew a sketch of the vessel."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_9",
      "id": "fn1_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" The American Civil War brought on a flurry of submarine designs, few of which had any impact on naval warfare at the time other than the Confederate submarine "), _c('i', [_vm._v("Hunley")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_10",
      "id": "fn1_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Floating and sub-surface mines, however, became a common defensive technology used by the Confederacy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_11",
      "id": "fn1_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The "), _c('i', [_vm._v("Hunley")]), _vm._v(" carried a device referred to as a “spar torpedo,” an explosive device held at the end of a long pole or spar. That system became a common weapon used on small surface vessels called torpedo-boats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A self-propelled torpedo would not appear until after the Civil War, initiated during the late 1860s by an English engineer, Robert Whitehead, based "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("on a concept by an Austrian naval officer, Giovanni Luppis. Several countries purchased Whitehead torpedoes, or the manufacturing rights, in the 1870s. By 1875, designs were being considered within the U.S. Navy, specifically at the Naval Torpedo Station in Newport, Rhode Island.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Introductory remarks to a publication titled “Notes on Movable Torpedoes” produced between 1874 and 1875 at the torpedo station defined the prevailing opinion regarding these new weapons. Submarine mines, or what were called “stationary torpedoes,” which proliferated during the Civil War, were considered primarily “for defense of channels against the entry of fleets.” Yet by the decade of the 1870s, these new “Movable or Locomotive Torpedoes to assail ships on the high seas” were becoming a reality."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_12",
      "id": "fn1_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" In this same publication was an 1873 article by an Austrian officer, Lieutenant J. Lehnert, titled “Torpedo Vessels in Naval Engagements,” in which he predicted the interest, and dread, this new weapon was about to bring to the world:")]), _vm._v(" "), _c('p', {
    staticClass: "quotet"
  }, [_vm._v("The gradual and probable introduction of Torpedo vessels into fleets, the general emotion which the appearance of these terrible engines has created, the attention with which seamen of all countries watch the progress of this new arm, now an offensive power, and finally the complete revolution which they will probably produce in naval tactics are sufficient reasons for rendering the study of Torpedoes not only necessary, but attractive to officers of all navies.")]), _vm._v(" "), _c('p', {
    staticClass: "quotei"
  }, [_vm._v("Torpedoes carried by vessels constructed for that purpose, and which, discharged in a given direction, retain under water a motion which is inherent in them and thus reach the enemy at considerable distances. This system is known under the name of Whitehead-Lupis [or Fish] Torpedoes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_13",
      "id": "fn1_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Lieutenant Francis M. Barber, instructor at the torpedo station, wrote his “Lecture on the Whitehead Torpedo,” a thorough description of what was known about the torpedo in 1874."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_14",
      "id": "fn1_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" At that time, the U.S. Navy was considering production of its own torpedo, which Barber described in a section titled “Plans for Fish Torpedo Submitted to Board of Ordnance, June 1st, 1874.” Barber mentioned that the “general idea which was originally intended to control the construction of this proposed fish was to approximate as closely as possible to what was supposed to be the plan of the Whitehead …”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_15",
      "id": "fn1_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Barber then added a copy of a letter to Commodore Wm. Jeffers, Chief of the Bureau of Ordnance, from Lieutenant Commander W.M. Folger, a naval observer at the Whitehead factory in Fiume, Austria, January 6, 1875. Folger "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("had arrived at the factory two days earlier and met with Whitehead. The worldwide interest was becoming obvious:")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("The German government has ordered from the Messrs. Whitehead & Co. 100 of the latest improved torpedoes, and had advanced funds for the establishment of a regular torpedo factory…. The French government has ordered 50 … In addition to those already known to the Bureau, the subject is being considered by the Governments of Russia, Denmark, and Belgium."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_16",
      "id": "fn1_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was still premature to see these “fish” torpedoes launched from a submarine, but by the end of the century, John Holland was ready to provide the U.S. Navy with this capability. Other nations were also anxious to enter the new century with at least a small fleet of submarines outfitted with Whitehead torpedoes, and the Holland Torpedo Boat Company had a major influence on these early efforts. The Navy’s first submarine, the USS "), _c('i', [_vm._v("Holland")]), _vm._v(" (SS-1), commissioned in 1900, had a single torpedo tube and carried three torpedoes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_17",
      "id": "fn1_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" As Germany quietly prepared for war, the next decade saw major changes in submarine designs and operational capabilities, along with improvements in torpedoes. This became the weapon that brought the U-boat its fame—and infamy.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTER")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HITEHEAD")]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHWARTZKOPFF AND")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LISS")]), _vm._v("-L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAVITT")])]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("At the beginning of the war the torpedo factory at Friedrichsort had been the only place where our torpedoes were manufactured; but during the war the engineering works (formerly L. Schwartzkopff) in Berlin, which in earlier years had also manufactured torpedoes, was converted into a torpedo factory, as were other works as well."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_18",
      "id": "fn1_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Admiral Scheer continued: “Under the direction of the Chief of the Torpedo Factories, Rear-Admiral Hering, the enormously increased demand for the manufacture of torpedoes was fully satisfied …”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_19",
      "id": "fn1_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" By 1917, German submarines were being sent to sea fully anticipating the use of their increased capacity to carry torpedoes (see next page). Prior to 1917, however, much of the destruction of commercial vessels was accomplished when the U-boat had surfaced and fired on the unarmed vessels with deck-mounted guns, leaving their expensive torpedoes for larger, high-value prey. Britain’s Admiral John Rushworth Jellicoe recognized that “before the days of the unrestricted submarine campaign, and although ships were frequently torpedoed, very large numbers were still being sunk by gun-fire.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_20",
      "id": "fn1_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg16.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_c('i', [_vm._v("Schwartzkopff torpedoes captured during the Spanish-American War and held at the Naval Torpedo Station, Newport, Rhode Island")]), _vm._v(". (NHHC "), _c('i', [_vm._v("NH 84471")]), _vm._v(") Inset: "), _c('i', [_vm._v("Detonator on one of the remaining examples of the Schwartzkopff torpedo")]), _vm._v(". (Courtesy Naval Undersea Warfare Center; Richard Allen)")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("In the United States, torpedo development was centered at the Naval Torpedo Station in Newport, Rhode Island, beginning in 1869. In 1920, a pamphlet produced at the torpedo station outlined its five decade history."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_21",
      "id": "fn1_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" By the end of the nineteenth century, several hundred torpedoes of various designs had been purchased for testing in Narragansett Bay—the Hall, Lay, Howell, and the wire-guided Patrick torpedoes, for example—but the most popular was the Whitehead. During the Spanish American War, however, even the German Schwartzkopff torpedo was among the station’s inventory, where a “tube was mounted for experimental purposes, and twelve torpedoes were purchased and sent to the station.” After the war, the torpedo station received sixteen of these torpedoes recovered from Spanish ships. Many were so badly damaged, however, that “[the] shells of these torpedoes are still in use [in 1920] at the Station as light "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("posts.” In 1900, the Navy’s first submarine, the USS "), _c('i', [_vm._v("Holland")]), _vm._v(", arrived in Narragansett Bay, armed with three Whitehead Mark II torpedoes. During sea trials, the "), _c('i', [_vm._v("Holland")]), _vm._v(" demonstrated the ability to approach the battleship "), _c('i', [_vm._v("Kearsarge")]), _vm._v(" undetected."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_22",
      "id": "fn1_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1904, the U.S. Navy contracted the E.W. Bliss Company to produce a torpedo similar to the Whitehead, based on designs by Frank M. Leavitt. A factory to accommodate an anticipated need for increased production was built at the station in 1907. The following are excerpts from the torpedo station pamphlet:")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("In September 1912 an order was received for ninety Mark VII Mod 2 Bliss-Leavitt Torpedoes…. By 1915 the effect of the European War, which threatened to involve the armament of the world, was being anticipated in America and the preparedness which was being talked about throughout the country was being actively practiced at the Torpedo Station…. Early in 1917 an open break with Germany was obvious and preparations were made at the Station to meet the emergency…. Station activities were further increased and the [civilian] working force enlarged to three thousand two hundred employees…. Navy personnel during the war numbered about thirteen hundred."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_23",
      "id": "fn1_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Torpedoes, fired from surface ships as well as submarines during the Great War, were about to define the weaponry of twentieth-century naval warfare. A reminder is appropriate here: Soviet submarines dispatched to North American waters during the Cuban Missile Crisis in 1962 carried nuclear-tipped torpedoes.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DMIRAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EINHARD")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHEER")]), _vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDATOR")])]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("When the U-boat campaign was opened on February 1, 1917, there were 57 boats already in the North Sea. The officer commanding the Baltic district had eight assigned to him, the Naval Corps in Flanders had at its disposal 38, and the stations in the Mediterranean 31 boats of different types…. With this fleet of U-boats the Navy was well equipped to do justice to the task assigned to it, although England had used the whole of 1916 to develop her defense."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_24",
      "id": "fn1_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Admiral Scheer, convinced of the predatory efficiency of Germany’s fleet of U-boats, became a proponent of a renewed dependency on submarine warfare early in 1917, in spite of the likely entry of the United States into the war ("), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9")]), _vm._v("). The two visits of Germany’s mercantile submarine "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('i', [_vm._v("Deutschland")]), _vm._v(" to American ports in 1916 (")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 10")]), _vm._v(") had provided credible evidence to Admiral Scheer that long-range operations were possible:")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("When they could no longer be used for trade purposes the commercial U-boats were taken over by the Navy and altered for use as warships. They were fitted with two guns of 15 cm. caliber and two torpedo tubes, and could carry about 30 torpedoes in accordance with the extended period during which they could be used on cruises …"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_25",
      "id": "fn1_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With significant firepower when on the surface or while submerged, the U-boat predators controlled the oceans. The images on "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 68")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter10#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")]), _vm._v(" are examples of Germany’s cruiser submarines adopted after the successful trips of "), _c('i', [_vm._v("Deutschland")]), _vm._v(". In response, drastic measures had to be put into place by the Admiralty—and quickly. Admiral Jellicoe devoted a chapter in his book "), _c('i', [_vm._v("The Grand Fleet, 1914-1916")]), _vm._v(" to Britain’s early actions against German submarines."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_26",
      "id": "fn1_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Referring to operations during 1915, Jellicoe expressed concern over the relative lack of success by the vessels Britain was using at the time, primarily destroyers. By that summer, several depth charge designs were being developed and carried by destroyers.")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("On July 1st the "), _c('i', [_vm._v("Hampshire")]), _vm._v(" reported that a torpedo had been fired at her in the Moray Firth. Twelve destroyers were sent to endeavour to locate and sink the submarine…. The boats exploded a large number of charges on the bottom in the hope of forcing any submarine to the surface."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_27",
      "id": "fn1_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While there was no evidence that the above account resulted in the destruction of that U-boat, the prevailing strategy, besides ramming a surfaced submarine or dropping depth charges at its suspected location, was “to keep the submarine down long enough to cause her to exhaust her battery power, a period of some 48 hours.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_28",
      "id": "fn1_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" There had also been accounts of British submarines finding and sinking a surfaced U-boat with a torpedo."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_29",
      "id": "fn1_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Once submerged and free to maneuver at will, however, German submarines continued to be an elusive target."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_30",
      "id": "fn1_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The solution was the hydrophone, though it would take more than two-and-a-half years, and America’s entry into the war, before this technology began to become a U-boat deterrent. Even by the end of 1916, according to Admiral Jellicoe, “[the] hydrophone had been in the experimental stage and under trial for a considerable period, but it had not so far developed into an effective instrument for locating submarines …”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_31",
      "id": "fn1_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" adding that … “all devices for use afloat suffered from the disadvantage that it was not possible "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("to use them whilst the ship carrying them was moving … [the ship], when stopped, an easy target for the submarine’s torpedo.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_32",
      "id": "fn1_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("Of all the weapons used in the anti-submarine war the two most important were the "), _c('i', [_vm._v("hydrophone")]), _vm._v(" and the "), _c('i', [_vm._v("depth charge")]), _vm._v(". They were employed in conjunction with each other and comprised the surface warship’s principal means of offense against submarines operating beneath the surface."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_33",
      "id": "fn1_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This assessment by Charles Domville-Fife, who commanded a British hydrophone flotilla during the Great War, underscored the significance of hydrophone detection, which would lead to a targeted location for the depth charges. Without the ability to provide a precise location of a submerged U-boat, however, dropping a barrage of depth charges was just a hit-or-miss attack. Perfecting the hydrophone would take time and resources. Early efforts within the British and French Admiralties were aided by their scientists and engineers who searched for ways to exploit the physics of underwater sound. Domville-Fife emphasized the importance of the hydrophone, which “enables the surface ship to discover, first, the presence of the submarine … and, secondly, its approximate location … When a surface ship is hot on the track of a moving submarine she endeavours to attain a position directly over the top of her quarry, or even a little ahead, and then releases one or more depth charges according to whether the chance of a hit is good or only poor.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes#rfn1_34",
      "id": "fn1_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The story of "), _c('i', [_vm._v("The Listeners")]), _vm._v(" begins with a single British officer assigned to a naval base in Scotland’s Firth of Forth. With a background in radio communication, Commander C. P. Ryan began experimenting with crude devices comprised of microphones housed in home-made, watertight containers. Ryan was soon able to hear, and distinguish from other vessels, the sound of a submarine. The technology continued to improve with significant advances occurring after America entered the war. The hunters, armed with an ample supply of depth charges, would soon have the tools they needed to detect, pursue, and destroy a German submarine—Admiral Scheer’s predators would become the prey.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1833deac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter01.vue
// module id = 84
// module chunks = 0